import { frontendURL } from 'dashboard/helper/URLHelper';

// custom (Metas · F4): Início — home de entrada de TODOS os usuários (top-level).
// NÃO é uma sub-rota do CRM: é a landing padrão do app (1º item da sidebar) e o
// destino do redirect pós-login (ver inicioLandingGuard em conversation.routes.js).
// O nome da rota segue `crm_metas_home` (identificador interno, não visível) para
// não quebrar guard/activeOn/referências. A tela é a Home do Operador (Metas).
// pt-BR locked, white-mode.
export const inicioRoutes = [
  {
    path: frontendURL('accounts/:accountId/inicio'),
    name: 'crm_metas_home',
    component: () => import('./CrmMetasHome.vue'),
    meta: {
      permissions: ['administrator', 'agent'],
    },
  },
  // custom (2026-08-08): a conversa com o assistente, em TELA CHEIA. Mora ao lado do Início
  // e não dentro do CRM porque é a mesma pergunta que se faz do Início — a Home só abre a
  // porta (ver CrmAskIA.vue). Não entra na barra de navegação de propósito: o caminho até
  // ela é o campo da Home, e um item de menu para uma tela que só responde cinco perguntas
  // prometeria mais do que ela entrega.
  {
    path: frontendURL('accounts/:accountId/assistente'),
    name: 'crm_assistente',
    component: () => import('./CrmAssistente.vue'),
    meta: {
      permissions: ['administrator', 'agent'],
    },
  },
];
